import AppUtils from "./utils/AppUtils";
import ServiceWorkerUtils from "./utils/ServiceWorkerUtils";
import ApiUtils from "./utils/ApiUtils";

export class PushNotification {

    static async subscribeToPN(swReg: ServiceWorkerRegistration) {
        const subscribeOptions = {
            userVisibleOnly: true,
            applicationServerKey: AppUtils.urlBase64ToUint8Array("BG373TflPOcyFkp5ivp0W0PCHpHS_D_9FYKRn0AnGrsHchhonqy8czjzuJWCZsIqZ88wPEILlZf_TkdGs_mWIlw")
        }
        // TODO: try to work on this workaround and replace with serviceWorker.ready
        await new Promise((resolve) => {
            setTimeout(() => {
                resolve()
            }, 2000)
        })
        return swReg.pushManager.subscribe(subscribeOptions);
    }

    static init(subscriptionUrl: string, blockUrl: string, notificationPermissionStatus: string): Promise<boolean> {
        return new Promise((resolve, reject) => {
            ServiceWorkerUtils.register().then((swReg: any) => {
                return this.subscribeToPN(swReg);
            })
            .then((pnRegistrationKeys: PushSubscription) => {
                return this.sendSubscriptionToBackEnd(pnRegistrationKeys, subscriptionUrl);
                // if (notificationPermissionStatus !== "granted") {
                // } else {
                //     resolve(true)
                // }
            })
            .then(resText => {
                console.log(resText);
                resolve(true);
            })
            .catch(err => {
                console.error(err);
                this.failedSubscriptionCallBack(blockUrl);
                reject(err);
            })
        })
    }

    static failedSubscriptionCallBack(failedUrl: string) {
        // return fetch(failedUrl, {
        //     method: "POST",
        //     headers: {
        //         "Content-Type": "application/json"
        //     },
        // });
        return ApiUtils.apiPostRequest(failedUrl, JSON.stringify({}))
    }

    static sendSubscriptionToBackEnd(subscription: PushSubscription, subscriptionUrl: string) {
        // return fetch(subscriptionUrl, {
        //     method: "POST",
        //     headers: {
        //         "Content-Type": "application/json"
        //     },
        //     body: JSON.stringify(subscription)
        // });
        return ApiUtils.apiPostRequest(subscriptionUrl, JSON.stringify(subscription))
    }

}